import * as React from 'react';

import {setBodyId} from '../../../dom';
import {PageContainer, PageTitleBar} from '../../../ui/layout';
import {InvoiceTemplatePage} from '../../../ui/setup/sales-documents/invoices/invoice-template-page';

export function InvoiceTemplatePageStandalone() {
    setBodyId('invoice-template');

    return (
        <PageContainer
            noPadding={true}
            title='Invoice Template'
            whiteBackground={true}
            pageTitleBar={
                <PageTitleBar
                    title='Invoice template'
                    subheaderPrimaryText='Set up your default information for faster and efficient invoices.'
                />
            }
        >
            <InvoiceTemplatePage />
        </PageContainer>
    );
}
